import { IEventType } from "../types/IEventType";
import { IServiceEvent } from "../types/IServiceEvent";

export default function getLatestRuns(events: IServiceEvent[]) {
    const sorted = events.sort(function (x: IServiceEvent, y: IServiceEvent) {
        return (
            parseInt(y.eventId.split(":")[1]) -
            parseInt(x.eventId.split(":")[1])
        );
    });

    if (!sorted || !sorted[0]) {
        return {};
    }

    const lastError = sorted.find((event) => event.type == IEventType.ERROR);
    const lastSuccess = sorted.find(
        (event) => event.type == IEventType.SUCCESS
    );

    return {
        lastSuccess: lastSuccess ? lastSuccess.eventId.split(":")[1] : null,
        lastError: lastError ? lastError.eventId.split(":")[1] : null
    };
}

const baseGraphSections: { [key: string]: string } = {
    'Fleet Homepage': '#64B5F6',
    'Fleet Grade': '#BA68C8',
    'Fleet Sub Grade': '#A5D6A7',
    'Fleet Defects': '#F48FB1',
    'Fleet PSC': '#FFCC02',
    'My Orders': '#4FC3F7',
    'My Quotations': '#FFB74D',
    'My Reports': '#81C784',
    'Screening': '#FF8A65'
};

export const getSectionColour = (section: string): string => {
    const cleanSection = section.replace('Watercraft ', '');
    return baseGraphSections[cleanSection] || '#ffffff';
};